exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-modal-description {\n  margin-top: 8px;\n}\n.fields-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n@media (max-width: 1024px) {\n.fields-grid {\n    grid-template-columns: repeat(2, 1fr);\n}\n}\n@media (max-width: 640px) {\n.fields-grid {\n    grid-template-columns: 1fr;\n}\n}\n", ""]);

// exports
